#@import Booking.Collections.Base
#@import Booking.Models.PossibleSegment
#@export Booking.Collections.PossibleSegments

class Booking.Collections.PossibleSegments extends Booking.Collections.Base
  model: Booking.Models.PossibleSegment
